import { jsx, jsxs } from "react/jsx-runtime";
function NoPermission() {
    return /*#__PURE__*/ jsxs("svg", {
        width: "440",
        height: "360",
        viewBox: "0 0 440 360",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ jsxs("g", {
                clipPath: "url(#clip0_1362_1122)",
                children: [
                    /*#__PURE__*/ jsx("ellipse", {
                        cx: "301.463",
                        cy: "152.657",
                        rx: "16.5",
                        ry: "18.5",
                        transform: "rotate(-3.21019 301.463 152.657)",
                        fill: "#B1BCD3"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M298.772 134.381L324.944 283.307",
                        stroke: "#8293A9",
                        strokeWidth: "1.5"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M307.538 136.74L301.321 148.684",
                        stroke: "#8293A9",
                        strokeWidth: "1.5"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M302.118 154.012L310.507 147.397",
                        stroke: "#8293A9",
                        strokeWidth: "1.5"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M292.778 155.727L304.536 166.688",
                        stroke: "#8293A9",
                        strokeWidth: "1.5"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M295.503 148.867L301.903 152.48",
                        stroke: "#8293A9",
                        strokeWidth: "1.5"
                    }),
                    /*#__PURE__*/ jsx("ellipse", {
                        cx: "335.565",
                        cy: "176.709",
                        rx: "16.5",
                        ry: "18.5",
                        transform: "rotate(6.13978 335.565 176.709)",
                        fill: "#B1BCD3"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M335.879 158.238L335.879 283.162",
                        stroke: "#798CA4",
                        strokeWidth: "1.50301"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M344.145 161.991L336.071 172.766",
                        stroke: "#798CA4",
                        strokeWidth: "1.5"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M335.991 178.152L345.344 172.988",
                        stroke: "#798CA4",
                        strokeWidth: "1.5"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M326.497 178.327L336 191",
                        stroke: "#798CA4",
                        strokeWidth: "1.5"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M330.301 172.002L336.029 176.606",
                        stroke: "#798CA4",
                        strokeWidth: "1.5"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M305.224 292.156H367.224L355 349.821H303L305.224 292.156Z",
                        fill: "#AEB3BB"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M306.224 292.156H368.224L356 349.821H304L306.224 292.156Z",
                        fill: "#8396AE"
                    }),
                    /*#__PURE__*/ jsx("rect", {
                        width: "60",
                        height: "14.2803",
                        transform: "matrix(1 0 -0.197144 0.980375 313.167 283.156)",
                        fill: "#8396AE"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M327.5 297.156H367.211L366 303.156L327.5 297.156Z",
                        fill: "#5C7089"
                    }),
                    /*#__PURE__*/ jsx("rect", {
                        width: "199",
                        height: "140",
                        rx: "8",
                        transform: "matrix(1 0 -0.107305 0.994226 125 211.156)",
                        fill: "#D3D8E0"
                    }),
                    /*#__PURE__*/ jsx("rect", {
                        width: "199",
                        height: "140",
                        rx: "8",
                        transform: "matrix(1 0 -0.107305 0.994226 122 211.156)",
                        fill: "#8396AE"
                    }),
                    /*#__PURE__*/ jsx("rect", {
                        width: "181",
                        height: "122",
                        rx: "2",
                        transform: "matrix(1 0 -0.115457 0.993312 131 220.156)",
                        fill: "#F4F8FF"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M264.983 172.684L268.768 173.477C269.858 173.705 270.844 173.654 271.727 173.323C272.617 172.974 273.378 172.389 274.012 171.57C274.646 170.75 275.153 169.755 275.533 168.585C275.901 167.452 276.058 166.433 276.005 165.529C275.957 164.607 275.684 163.845 275.185 163.245C274.705 162.648 273.968 162.246 272.974 162.037C272.19 161.873 271.397 161.925 270.595 162.194C269.794 162.462 269.075 162.947 268.439 163.647C267.809 164.328 267.326 165.189 266.988 166.229L259.647 164.691C260.359 162.499 261.481 160.681 263.012 159.236C264.568 157.776 266.367 156.764 268.408 156.2C270.455 155.617 272.568 155.554 274.748 156.011C277.099 156.503 279.022 157.372 280.516 158.618C282.029 159.868 283.002 161.46 283.435 163.396C283.893 165.317 283.712 167.541 282.891 170.068C282.493 171.294 281.862 172.451 280.998 173.54C280.153 174.632 279.102 175.573 277.846 176.361C276.595 177.131 275.189 177.659 273.625 177.947C272.081 178.238 270.41 178.196 268.613 177.819L263.653 176.78L264.983 172.684ZM263.083 178.535L264.386 174.523L269.346 175.562C271.392 175.991 273.057 176.617 274.34 177.442C275.643 178.271 276.6 179.255 277.21 180.394C277.839 181.538 278.158 182.785 278.169 184.137C278.198 185.492 277.971 186.913 277.489 188.399C276.873 190.293 276.009 191.918 274.895 193.272C273.807 194.611 272.523 195.671 271.044 196.453C269.585 197.238 268.012 197.742 266.327 197.964C264.667 198.172 262.958 198.091 261.199 197.723C259.67 197.402 258.264 196.86 256.981 196.095C255.723 195.316 254.684 194.334 253.864 193.15C253.069 191.952 252.582 190.56 252.403 188.975C252.248 187.376 252.488 185.601 253.122 183.65L260.462 185.188C260.106 186.284 259.99 187.302 260.114 188.24C260.244 189.16 260.575 189.934 261.106 190.561C261.637 191.188 262.362 191.598 263.279 191.79C264.292 192.002 265.241 191.943 266.124 191.612C267.026 191.286 267.814 190.716 268.485 189.905C269.183 189.079 269.733 188.043 270.137 186.799C270.626 185.294 270.811 184.033 270.692 183.017C270.573 182 270.182 181.193 269.518 180.598C268.879 179.988 267.995 179.565 266.868 179.328L263.083 178.535Z",
                        fill: "#2166FF"
                    }),
                    /*#__PURE__*/ jsx("rect", {
                        x: "203",
                        y: "341.156",
                        width: "100",
                        height: "9",
                        rx: "4.5",
                        fill: "#BFCAD8"
                    }),
                    /*#__PURE__*/ jsx("rect", {
                        x: "26",
                        y: "341.156",
                        width: "184",
                        height: "9",
                        rx: "4.5",
                        fill: "#86909C"
                    }),
                    /*#__PURE__*/ jsx("rect", {
                        x: "183",
                        y: "46",
                        width: "68",
                        height: "8",
                        fill: "#A8B7C9"
                    }),
                    /*#__PURE__*/ jsx("rect", {
                        x: "251",
                        y: "46",
                        width: "24",
                        height: "8",
                        fill: "#7E90A7"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        opacity: "0.3",
                        d: "M80 341.34L192.635 54H265.378L361 341.34H80Z",
                        fill: "url(#paint0_linear_1362_1122)"
                    }),
                    /*#__PURE__*/ jsx("rect", {
                        opacity: "0.5",
                        width: "154.135",
                        height: "51",
                        rx: "4",
                        transform: "matrix(1 0 -0.115457 0.993312 137.456 279.156)",
                        fill: "#CED8EA"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M187.647 306.768C188.849 306.193 190.201 306.321 191.119 307.096L218 329.816H172.042C170.201 329.816 168.893 328.317 169.138 326.49L170.43 316.839C170.592 315.631 171.41 314.533 172.558 313.984L187.647 306.768Z",
                        fill: "#C7D9FF"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M154.606 301.801C156.067 301.102 157.712 301.258 158.826 302.2L191.5 329.815H135.639C133.402 329.815 131.812 327.993 132.109 325.772L133.68 314.042C133.877 312.574 134.872 311.239 136.266 310.572L154.606 301.801Z",
                        fill: "#A4BFFA"
                    }),
                    /*#__PURE__*/ jsx("rect", {
                        width: "118.576",
                        height: "9.72396",
                        rx: "4",
                        transform: "matrix(1 0 -0.115457 0.993312 139.123 265.156)",
                        fill: "#D7E0EE"
                    }),
                    /*#__PURE__*/ jsx("rect", {
                        width: "153.9",
                        height: "9.72396",
                        rx: "4",
                        transform: "matrix(1 0 -0.115457 0.993312 139.123 249.156)",
                        fill: "#D7E0EE"
                    }),
                    /*#__PURE__*/ jsx("rect", {
                        width: "37.8416",
                        height: "9.72396",
                        rx: "4",
                        transform: "matrix(1 0 -0.115457 0.993312 141.123 233.156)",
                        fill: "#C4D4E7"
                    }),
                    /*#__PURE__*/ jsx("circle", {
                        cx: "8.15283",
                        cy: "8.15283",
                        r: "8.15283",
                        transform: "matrix(1 0 -0.115457 0.993312 265.647 288.289)",
                        fill: "#A4BFFA"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M368.5 310.656C367 310.656 326 314.156 319 353.156",
                        stroke: "#F1F5F7",
                        strokeWidth: "1.5"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M314 314.156C320.333 315.99 334.6 325.856 341 350.656",
                        stroke: "#F1F5F7",
                        strokeWidth: "1.5"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M363.5 322.656C361.5 322.656 355.7 325.656 353 330.156C350 335.156 352.5 344.656 358 347.156",
                        stroke: "#F1F5F7",
                        strokeWidth: "1.5"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M374.03 214.725C355.412 238.662 345.586 270.32 343 283.157H360.221C376.026 272.452 405.521 234.672 416.973 216.941C405.983 216.202 382.009 214.725 374.03 214.725Z",
                        fill: "#C2CCDC"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M368.982 221.902C369.419 221.211 372.738 216.678 374.343 214.498L400.055 240.165C390.046 234.275 369.818 222.376 368.982 221.902Z",
                        fill: "#7C92B6"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M416.806 216.912L374.264 214.354C383.126 229.812 419.019 258.351 430.24 259.992C431.077 246.591 421.692 225.357 416.806 216.912Z",
                        fill: "#C2D0E7"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M385.72 228.218C376.114 242.711 355.929 273.976 352.039 283.092",
                        stroke: "#798CA4"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M398.856 215.898L430.032 260.15",
                        stroke: "#798CA4"
                    }),
                    /*#__PURE__*/ jsx("circle", {
                        cx: "224.887",
                        cy: "215.829",
                        r: "2.69316",
                        stroke: "white",
                        strokeOpacity: "0.5",
                        strokeWidth: "0.6"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M122.827 281.448L122.735 281.461L122.33 281.366C97.7875 275.534 82.7928 253.065 85.7456 227.661L89.7492 193.217H91.9115C106.624 192.58 120.827 187.333 133.67 178.918L134.833 178.156L135.819 178.918C146.693 187.333 159.681 192.58 174.253 193.217H176.416L172.413 227.656C169.46 253.061 149.238 275.529 123.344 281.362L122.917 281.456L122.828 281.444L122.827 281.448Z",
                        fill: "#95A6BB"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M116.335 278.448L116.242 278.461L115.837 278.366C91.2953 272.534 76.3006 250.065 79.2534 224.661L83.257 190.217H85.4193C100.131 189.58 114.335 184.333 127.178 175.918L128.341 175.156L129.327 175.918C140.201 184.333 153.189 189.58 167.761 190.217H169.924L165.921 224.656C162.968 250.061 142.745 272.529 116.852 278.362L116.425 278.456L116.335 278.444L116.335 278.448Z",
                        fill: "#CBD6E6"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M117.381 269.45L117.305 269.461L116.97 269.383C96.7043 264.566 84.3224 246.013 86.7607 225.035L90.0666 196.593H91.8522C104.001 196.067 115.729 191.734 126.335 184.785L127.295 184.156L128.109 184.785C137.088 191.734 147.813 196.067 159.847 196.593H161.632L158.327 225.031C155.888 246.009 139.19 264.563 117.808 269.379L117.455 269.457L117.381 269.447L117.381 269.45Z",
                        fill: "#F4F8FF"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M136.588 219.448H108.555C106.134 219.448 103.961 221.395 103.702 223.798L101.71 242.25C101.451 244.653 103.203 246.6 105.624 246.6H133.658C136.079 246.6 138.252 244.653 138.512 242.25L140.503 223.798C140.762 221.395 139.009 219.448 136.588 219.448ZM122.966 232.899L122.443 237.742C122.334 238.756 121.419 239.578 120.399 239.578C119.379 239.578 118.641 238.756 118.751 237.742L119.273 232.899C118.239 232.264 117.623 231.081 117.77 229.722C117.989 227.694 119.819 226.051 121.859 226.051C123.898 226.051 125.375 227.694 125.156 229.722C125.009 231.081 124.138 232.264 122.966 232.899ZM124.454 202.006C117.316 202.006 110.916 207.679 110.112 215.132L109.496 220.833L135.216 222.056L135.963 215.132C136.768 207.679 131.593 202.006 124.454 202.006ZM113.226 220.51L113.82 215.005C114.367 209.937 118.944 205.827 124.041 205.827C129.14 205.827 132.828 209.937 132.282 215.005L131.673 220.639L113.226 220.51Z",
                        fill: "#2654B9"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M134.87 219.448H106.837C104.415 219.448 102.243 221.395 101.983 223.798L99.9918 242.25C99.7324 244.653 101.485 246.6 103.906 246.6H131.939C134.361 246.6 136.534 244.653 136.793 242.25L138.785 223.798C139.044 221.395 137.291 219.448 134.87 219.448ZM121.248 232.899L120.725 237.742C120.616 238.756 119.701 239.578 118.681 239.578C117.661 239.578 116.923 238.756 117.032 237.742L117.555 232.899C116.521 232.264 115.905 231.081 116.052 229.722C116.27 227.694 118.101 226.051 120.141 226.051C122.18 226.051 123.656 227.694 123.438 229.722C123.291 231.081 122.42 232.264 121.248 232.899ZM122.736 202.006C115.597 202.006 109.198 207.679 108.393 215.132L107.778 220.833L133.498 222.056L134.245 215.132C135.05 207.679 129.875 202.006 122.736 202.006ZM111.508 220.51L112.102 215.005C112.649 209.937 117.225 205.827 122.323 205.827C127.421 205.827 131.11 209.937 130.563 215.005L129.955 220.639L111.508 220.51Z",
                        fill: "#2166FF"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M234.372 161.517L235.76 168.589C236.388 171.789 236.639 174.587 236.512 176.98C236.384 179.374 235.937 181.402 235.169 183.066C234.416 184.706 233.379 186.014 232.058 186.99C230.733 187.947 229.189 188.598 227.425 188.945C226.026 189.219 224.672 189.266 223.363 189.085C222.05 188.885 220.806 188.433 219.633 187.728C218.475 186.999 217.402 185.996 216.415 184.717C215.446 183.434 214.579 181.853 213.812 179.973C213.06 178.071 212.432 175.835 211.928 173.267L210.54 166.195C209.908 162.975 209.657 160.178 209.788 157.804C209.938 155.426 210.399 153.414 211.171 151.77C211.943 150.126 212.994 148.835 214.322 147.897C215.647 146.94 217.191 146.289 218.954 145.943C220.353 145.668 221.708 145.621 223.017 145.802C224.326 145.983 225.549 146.43 226.684 147.143C227.834 147.832 228.903 148.817 229.891 150.096C230.874 151.356 231.742 152.937 232.494 154.839C233.242 156.723 233.868 158.949 234.372 161.517ZM228.604 171.068L226.792 161.84C226.484 160.269 226.146 158.902 225.778 157.74C225.411 156.578 225.024 155.619 224.617 154.863C224.206 154.088 223.758 153.479 223.273 153.037C222.807 152.591 222.312 152.3 221.788 152.164C221.26 152.009 220.718 151.986 220.162 152.095C219.453 152.234 218.858 152.55 218.377 153.042C217.893 153.516 217.533 154.213 217.296 155.136C217.055 156.039 216.963 157.191 217.019 158.594C217.075 159.996 217.295 161.674 217.679 163.629L219.491 172.857C219.803 174.448 220.145 175.834 220.516 177.015C220.902 178.173 221.303 179.149 221.718 179.944C222.151 180.734 222.603 181.362 223.073 181.828C223.538 182.273 224.035 182.574 224.563 182.729C225.091 182.884 225.643 182.905 226.218 182.792C226.927 182.653 227.522 182.337 228.002 181.845C228.498 181.33 228.855 180.613 229.073 179.694C229.291 178.776 229.36 177.608 229.281 176.19C229.217 174.75 228.991 173.042 228.604 171.068Z",
                        fill: "#2166FF"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M206.901 125.544L204.992 131.516L180.184 123.584L181.377 118.891L204.152 96.3372L209.816 98.1483L200.507 107.352L188.986 119.816L206.901 125.544ZM211.435 98.6658L198.444 139.296L191.273 137.003L204.263 96.3729L211.435 98.6658Z",
                        fill: "#2166FF"
                    })
                ]
            }),
            /*#__PURE__*/ jsxs("defs", {
                children: [
                    /*#__PURE__*/ jsxs("linearGradient", {
                        id: "paint0_linear_1362_1122",
                        x1: "124.348",
                        y1: "64.6219",
                        x2: "162.519",
                        y2: "204.07",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ jsx("stop", {
                                stopColor: "#165DFF",
                                stopOpacity: "0.74"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: "1",
                                stopColor: "#BAC9FF",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsx("clipPath", {
                        id: "clip0_1362_1122",
                        children: /*#__PURE__*/ jsx("rect", {
                            width: "440",
                            height: "360",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    });
}
export { NoPermission as default };
